export const DEFAULT_LANGUAGE = 'fi';
export const LANGUAGES = ['fi', 'sv', 'en', 'et'];

export const FIELD_IS_VALID = false;
export const ASSIGNMENT_VALID_FOR_EDIT = 'valid';
export const ASSIGNMENT_OLD = 'old';
export const ASSIGNMENT_FUTURE = 'future';

export const LEVELS = [
    {
        label: 'option_one',
        value: '0',
    },
    {
        label: 'option_two',
        value: '1',
    },
    {
        label: 'option_three',
        value: '2',
    },
    {
        label: 'option_four',
        value: '3',
    },
    {
        label: 'option_five',
        value: '4',
    },
];

export const ROLE_TEACHER = 'faculty';

export const COURSE_ONGOING = 'course_ongoing';
